import { StrapiActions, StrapiActionTypes, StrapiState } from '../../types/strapiGOS';

const initialState: StrapiState = {};

export const addForms = (state = initialState, action: StrapiActions): StrapiState => {
  switch (action.type) {
    case StrapiActionTypes.ADD_REQUEST_GOS: {
      const { modelName } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          loading: true,
          error: null,
        },
      };
    }

    case StrapiActionTypes.ADD_SUCCESS_GOS: {
      const { modelName, data, creatorId } = action.payload;
      return {
        ...state,
        [modelName]: {
          data: [...(state[modelName]?.data || []), data],
          loading: false,
          error: null,
          lastAddedId: data.id,
          lastDocId: data.documentId,
          lastAddedCreatorId: creatorId || null,
        },
      };
    }

    case StrapiActionTypes.ADD_FAILURE_GOS: {
      const { modelName, error } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          loading: false,
          error,
        },
      };
    }

    case StrapiActionTypes.UPDATE_REQUEST_GOS: {
      const { modelName } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          loading: true,
          error: null,
        },
      };
    }

    case StrapiActionTypes.UPDATE_SUCCESS_GOS: {
      const { modelName, data } = action.payload;
      const existingData = state[modelName]?.data || [];
      const updatedData = existingData.map((item: any) => (item.id === data.id ? data : item));
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          data: updatedData,
          loading: false,
          error: null,
          lastUpdatedId: data.id,
        },
      };
    }

    case StrapiActionTypes.UPDATE_FAILURE_GOS: {
      const { modelName, error } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          loading: false,
          error,
        },
      };
    }

    case StrapiActionTypes.DELETE_REQUEST_GOS: {
      const { modelName } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          loading: true,
          error: null,
        },
      };
    }

    case StrapiActionTypes.DELETE_SUCCESS_GOS: {
      const { modelName, documentId } = action.payload;
      const existingData = state[modelName]?.data || [];

      const filteredData = existingData.filter((item: any) => item.documentId !== documentId);
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          data: filteredData,
          loading: false,
          error: null,
        },
      };
    }

    case StrapiActionTypes.DELETE_FAILURE_GOS: {
      const { modelName, error } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          loading: false,
          error,
        },
      };
    }

    case StrapiActionTypes.SET_LAST_UPDATED_ID_GOS: {
      const { modelName, id } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          lastUpdatedId: id,
        },
      };
    }

    default:
      return state;
  }
};
